import { TranslationsContext } from '@teliaee/telia-translate';
import { observer } from 'mobx-react';
import React from 'react';
import { useStores } from '../../stores/RootStore';
import { hasTranslation } from './BranchCard';
import { AnalyticsTrigger, Button, Grid, GridColumn, Icon } from 'telia-front-react';
import { Branch } from '../common/ReservationInterfaces';

interface LocationLinkProps {
  branch: Branch;
}

const BranchLocation = observer((props: LocationLinkProps): React.JSX.Element => {
  const {
    languageStore: { currentLanguage },
  } = useStores();
  const {
    branch: { locationDescription, name, googleMapsLink, streetAddress },
  } = props;
  const { translate } = React.useContext(TranslationsContext);

  const renderAddress = (): React.JSX.Element => {
    const addressText = streetAddress[currentLanguage] || streetAddress.et;
    const addressComponent = (
      <Grid align={['middle-xs']} horizontalGutter="xsmall">
        <GridColumn width={['min']}>
          <Icon modifiers="#map-marker" size="xxs" className="text__margin-half" align="middle" />
        </GridColumn>
        <GridColumn width={['min']}>
          <strong className="text__margin-half">{addressText}</strong>
        </GridColumn>
      </Grid>
    );

    return googleMapsLink ? (
      <Grid align={['middle-xs']}>
        <GridColumn width={['min']}>{addressComponent}</GridColumn>
        <GridColumn width={['min']}>
          <AnalyticsTrigger trigger={{ callback: 'onClick', id: `Link - Maps - ${name}` }}>
            <Button url={`${googleMapsLink}`} link={true} text={translate('branch.address.open')} target="_blank" className="text__margin-half" />
          </AnalyticsTrigger>
        </GridColumn>
      </Grid>
    ) : (
      addressComponent
    );
  };

  return (
    <>
      {renderAddress()}
      {hasTranslation(locationDescription, currentLanguage) && (
        <p className="text-small text__margin-half">{locationDescription[currentLanguage] || locationDescription.et}</p>
      )}
    </>
  );
});

export default BranchLocation;
